import { cn } from '../lib/cn.js'

export function Skeleton({
  altura = 16,
  largura = '100%',
  circulo,
  className,
}: {
  altura?: number | string | undefined
  largura?: number | string | undefined
  circulo?: boolean | undefined
  className?: string | undefined
}) {
  return (
    <span
      className={cn('du-esqueleto', circulo && 'du-esqueleto--circulo', className)}
      style={{ height: altura, width: largura }}
      aria-hidden
    />
  )
}
